import React    from 'react'

const handleChange = (routerPush, e = {}) => {
  const { selectedIndex, options } = e.target || {}
  const selectedOption = options[selectedIndex]
  const path = selectedOption.getAttribute('data-url')

  if(path) {
    routerPush(path)
  }
}

export const DropdownSelect = (props) => {
  let showDefaultValue = false
  const {
    items         = [],
    selected      = '',
    formatUrl,
    routerPush
  } = props
  
  const options = items.map((item, i) => {

    let href = item.href || '#'

    if(typeof formatUrl === 'function' ) {
      href = formatUrl( item )
    }

    if (!showDefaultValue && selected === item.text) {
      showDefaultValue = true
    }
    
    return (
      <option key={i} data-url={href} name={item.trackingName} value={item.text}>{item.text}</option>
    )
  })

  return (
    <div className="dropdown-wrapper">
      <div className="mobile-dropdown">
        <span className="mobile-arrow"></span>
        <select onChange={handleChange.bind(null,routerPush)} value={selected}>
          { !showDefaultValue &&
            <option key="0" value={selected}>{selected}</option> || null
          }
          {options}
        </select>
      </div>
    </div>
  )

}

export default DropdownSelect



// WEBPACK FOOTER //
// ../app/components/common/DropdownSelect.jsx